define('formkit/view/form.object/content/table.content.view',['require','underscore','backbone','marionette','uikit/uikit','../../../templates','../../../model/template.object.model','../../../form.object.util','./base.selectable.content.view','bluebird','./base.content.view','../data.label.selector.view','../../../behavior/answer.value.failed.validations.behavior'],function(require) {
  //prettier-ignore
  var _                                    = require('underscore'),
      Backbone                             = require('backbone'),
      Mn                                   = require('marionette'),
      UIKit                                = require('uikit/uikit'),
      Templates                            = require('../../../templates'),
      TemplateObjectModel                  = require('../../../model/template.object.model'),
      FormObjectUtil                       = require('../../../form.object.util'),
      BaseSelectableContentView            = require('./base.selectable.content.view'),
      Promise                              = require('bluebird'),
      BaseContentView                      = require('./base.content.view'),
      DataLabelSelectorView                = require('../data.label.selector.view');
      AnswerValueFailedValidationsBehavior = require('../../../behavior/answer.value.failed.validations.behavior');

  var SELECTABLE_TEMPLATE_OBJECT_TYPES = ['Check Box', 'Radio Button', 'Dropdown'];

  var SidebarContentView = UIKit.ItemView.extend({
    template: Templates.App['table.object.settings.sidebar.content'],

    options: {
      designViewType: null,
      previewViewType: null,
      form: null,
      model: null,
    },

    internalViewOptions: {
      headerView: function() {
        return {
          type: UIKit.Header,
          text: 'Edit Column Settings',
          tagName: 'h4',
          color: 'primary',
        };
      },
      headerDividerView: function() {
        return {
          type: UIKit.Divider,
          section: true,
          visible: true,
        };
      },
      designDividerView: function() {
        return {
          type: UIKit.Divider,
          section: true,
          visible: true,
        };
      },
      previewTitleView: function() {
        return {
          type: UIKit.Text,
          model: this.model,
          bindings: {
            text: 'text',
          },
        };
      },
      previewTitleRequiredQuestionView: function() {
        return {
          type: UIKit.Text,
          model: this.model,
          text: '*',
          color: 'red',
          bindings: {
            visible: 'required',
          },
        };
      },
      previewView: function() {
        return {
          type: this.getOption('previewViewType'),
          form: this.getOption('form'),
          model: this.model,
          // always true since sidebar is only used inside designer
          readonly: true,
        };
      },
      designView: function() {
        return {
          type: this.getOption('designViewType'),
          form: this.getOption('form'),
          model: this.model,
        };
      },
      doneButtonView: function() {
        return {
          type: UIKit.Button,
          className: UIKit.Button.prototype.className + ' right floated',
          color: 'primary',
          text: 'Done',
        };
      },
    },

    onFirstRender: function() {
      this.listenTo(
        this.requiredQuestionView,
        'change:value',
        _.debounce(function() {
          this.form.util.insertValidationRule(this.model, this.getCustomValidationRule());
        })
      );
    },
  });

  var DesignAnswerItemView = BaseSelectableContentView.DesignAnswerItemView.extend({
    className: 'designview-table-columns',

    internalViewOptions: BaseSelectableContentView.DesignAnswerItemView.extendInternalViewOptions({
      typeDropdownView: function() {
        return {
          type: UIKit.Dropdown,
          placeholder: 'Select a type...',
          collection: this.templateObjectTypeCollection,
          childBindings: {
            text: 'description',
          },
          value: this.getSelectedDropdownValue(),
        };
      },
      previewSettingsView: function() {
        return {
          type: UIKit.Input,
          model: this.model,
          disabled: true,
        };
      },
      settingsButtonView: function() {
        return {
          type: UIKit.Button,
          model: this.model,
          icon: 'setting',
          color: 'primary',
          disabled: !this.isSelectableTemplateObjectType()
        };
      },
      requiredColumnView: function() {
        return {
          type: UIKit.Checkbox,
          model: this.model,
          bindings: {
            value: 'required',
          },
        }
      },
      dataLabelView: function() {
        return {
          type: DataLabelSelectorView,
          search: true,
          childViewOptions: {
            bindings: {
              text: 'value'
            }
          },
          model: this.model,
          form: this.form,
          collection: this.getCurrentTemplateTypeDataLabelCollection(),
          bindings: {
            value: 'dataLabel'
          }
        }
      },
      settingsSidebarView: function() {
        return {
          width: 'very wide',
        };
      },
    }),

    contentViewHasSettings: function() {
      var ContentView = this.form.getContentView(this.form.getTemplateObjectTypeName(this.model));

      return !!ContentView.DesignAnswerView;
    },

    getCurrentTemplateTypeDataLabelCollection: function() {
      return this.currentTemplateTypeDataLabelCollection;
    },

    setCurrentTemplateTypeDataLabelCollection: function(collection) {
      if(_.isArray(collection)) {
        collection = new Backbone.Collection(collection);
      }
      this.currentTemplateTypeDataLabelCollection = collection;
    },

    getSelectedDropdownValue: function() {
      var typeName = this.form.getTemplateObjectTypeName(this.model);
      var selectedType = this.form.findTemplateObjectTypeByName(typeName);

      // when a type is selected, we need to secure a reference to its dataLabels for the dataLabelView dropdown
      this.setCurrentTemplateTypeDataLabelCollection(selectedType.get('dataLabels'));

      // if this is the initial page load, there will not be a dataLabelView on first pass, so ignore it if it's not ready
      if (this.dataLabelView) {
        this.dataView.collection = this.getCurrentTemplateTypeDataLabelCollection();
      }

      return selectedType;
    },

    buildColumnManagerComponents: function() {
      var currentColumnNumber = this.model.collection.indexOf(this.model) + 1;

      // set up the base components
      this.labelInputView      = this.buildComponent({ name: 'labelInputView' });
      this.typeDropdownView    = this.buildComponent({ name: 'typeDropdownView' });
      this.dataLabelView       = this.buildComponent({ name: 'dataLabelView'});
      this.addButtonView       = this.buildComponent({ name: 'addButtonView', size: UIKit.Button.MINI });
      this.removeButtonView    = this.buildComponent({ name: 'removeButtonView', size: UIKit.Button.MINI });
      this.settingsButtonView  = this.buildComponent({ name: 'settingsButtonView', size: UIKit.Button.MINI });
      this.requiredColumnView  = this.buildComponent({ name: 'requiredColumnView' });

      // set up the button container and add the button views
      this.buttonContainerView = new UIKit.Container({ className: 'ui buttons' });
      this.buttonContainerView.add( this.addButtonView );
      this.buttonContainerView.add( this.removeButtonView );
      this.buttonContainerView.add( this.settingsButtonView );

      // set the aria-labelledby attributes for accessibility
      this.labelInputView.updateElementAttributes({ 'aria-labelledby': 'columnHeaderLabel' });
      this.typeDropdownView.updateElementAttributes({ 'aria-labelledby': 'typeHeader' });
      this.dataLabelView.updateElementAttributes({ 'aria-labelledby': 'dataLabelHeader' });
      this.buttonContainerView.updateElementAttributes({ 'aria-labelledby': 'buttonViewHeader', role: 'group' });
      this.requiredColumnView.updateElementAttributes({ 'aria-labelledby': 'requiredHeader' });
      this.addButtonView.updateElementAttributes({ 'aria-label': 'Add a new column to the table'});
      this.removeButtonView.updateElementAttributes({ 'aria-label': 'Remove column ' + currentColumnNumber + ' from the table'});
      this.settingsButtonView.updateElementAttributes({ 'aria-label': 'Configure the choices for column ' + currentColumnNumber });

      return this;
    },

    isSelectableTemplateObjectType: function() {
      var currentlySelectedTemplateObjectType = this.typeDropdownView.value
                                                  ? this.typeDropdownView.value.get('description')
                                                  : '';

      return SELECTABLE_TEMPLATE_OBJECT_TYPES.indexOf(currentlySelectedTemplateObjectType) > -1;
    },

    attachComponentsToFormView: function() {
      var useDataLabels = this.form.localConfig ? this.form.localConfig.get('formkit.useDataLabels') : false;
      // Apply labels only to the top row of items, not every row
      var labelConfigs  = this.model.collection.indexOf(this.model) === 0
                              ? [
                                  { text: 'Column Header', attributes: { id: 'columnHeaderLabel' } },
                                  { text: 'Type', attributes: { id: 'typeHeader' } },
                                  { text: 'Label', required: true, attributes: { id: 'dataLabelHeader' } },
                                  { text: 'Add/Remove/Config', attributes: { id: 'buttonViewHeader' } },
                                  { text: 'Required', attributes: { id: 'requiredHeader' } }
                                ]
                              : [ { text: '' },{ text: '' },{ text: '' },{ text: '' },{ text: '' } ];
      var formView = this.formView.addGroup();

      formView
        .addField(_.extend({ width: useDataLabels ? 3 : 5 }, labelConfigs[0]), this.labelInputView)
        .parent()
        .addField(_.extend({ width: useDataLabels ? 4 : 6 }, labelConfigs[1]), this.typeDropdownView)
        .parent();

      if (useDataLabels) {
        formView
          .addField(_.extend({ width: 4 }, labelConfigs[2]), this.dataLabelView)
          .parent();
      }
      formView
        .addField(_.extend({ width: 3 }, labelConfigs[3]), this.buttonContainerView)
        .parent()
        .addField(_.extend({ width: 2 }, labelConfigs[4]), this.requiredColumnView)
        .parent();

      return this;
    },

    setupForm: function() {
      this.formView.size = 'small';

      this.buildColumnManagerComponents()
          .attachComponentsToFormView()
          .setupAddButtonView()
          .setupRemoveButtonView()
          .setupSettingsButtonView()
          .setupTypeDropdownView();
    },

    setupTypeDropdownView: function() {
      var typeDropdownView = this.formView.typeDropdownView;

      this.listenTo(typeDropdownView, 'change:value', function() {
        var currentParent = this.form.util.parent(this.model);
        var currentIndex = this.form.util.indexOfChild(currentParent, this.model);
        this.form.insertTemplateObject(
          currentParent,
          {
            text: this.model.get('text'),
            type: typeDropdownView.value,
          },
          currentIndex
        );
        this.form.detachTemplateObject(this.model);
      });

      return this;
    },

    setupSettingsButtonView: function() {
      this.listenTo(this.settingsButtonView, 'press', function() {
        this.buildAndShowSidebar();
      });

      return this;
    },

    buildAndShowSidebar: function() {
      this.settingsSidebarView = this.buildComponent({ name: 'settingsSidebarView', type: this.getSidebarType() });
      this.settingsSidebarView.visible = true;

      // when sidebar is closed, destroy it, so that there are no duplicates
      this.listenToOnce(this.settingsSidebarView, 'sidebar:hidden', function() {
        this.settingsSidebarView.destroy();
      });
    },

    getSidebarType: function() {
      var ContentView = this.form.getContentView(this.form.getTemplateObjectTypeName(this.model));

      return UIKit.Sidebar.extend({
        internalViewOptions: {
          contentView: {
            type: SidebarContentView,
            previewViewType: ContentView.PreviewAnswerInsideTableView || ContentView.PreviewAnswerView,
            designViewType: ContentView.DesignAnswerView,
            form: this.form,
            model: this.model,
          },
        },

        onContentViewDoneButtonViewPress: function() {
          this.hide();
        },
      });
    },
  });

  var DesignAnswerCollectionView = BaseSelectableContentView.DesignAnswerCollectionView.extend({
    childView: DesignAnswerItemView,
    childViewOptions: function() {
      return _.extend(
        {},
        Mn._getValue(BaseSelectableContentView.DesignAnswerCollectionView.prototype.childViewOptions, this),
        {
          templateObjectTypeCollection: this.templateObjectTypeCollection,
        }
      );
    },
  });

  var DesignAnswerView = BaseSelectableContentView.DesignAnswerView.extend({
    template: Templates.App['table.object.design'],

    internalViewOptions: BaseSelectableContentView.DesignAnswerView.extendInternalViewOptions({
      collectionView: function() {
        return {
          type: DesignAnswerCollectionView,
          templateObjectTypeCollection: this.templateObjectTypeCollection,
        };
      },
    }),
  });

  var TableHeaderCellView = UIKit.Table.HeaderCellView.extend({
    template: Templates.App['table.object.header.cell'],

    internalViewOptions: {
      requiredQuestionView: function() {
        return {
          type: UIKit.Text,
          model: this.model,
          color: 'red',
          text: '*',
          bindings: {
            visible: 'required',
          },
        };
      },
      textView: function() {
        return {
          type: UIKit.Text,
          model: this.model,
          bindings: {
            text: 'text',
          },
        };
      },
    },
  });

  var PreviewAnswerView = UIKit.ItemView.extend({
    template: Templates.App['table.object.preview'],

    options: {
      designable: false,
      readonly: false,
    },

    internalViewBindings: {
      tableView: {
        readonly: 'readonly',
      },
      addRowButtonView: {
        disabled: 'readonly',
      },
    },

    internalViewOptions: {
      tableView: function() {
        return {
          type: UIKit.Table,
          collection: this.collection,
          headerCellView: TableHeaderCellView,
        };
      },
      addRowButtonView: function() {
        return {
          type: UIKit.Button,
          icon: 'plus',
          size: 'small',
          color: 'primary',
          text: 'Add Row',
        };
      },
    },

    modelEvents: {
      'add:child remove:child reset:children': 'setupTableView',
    },

    onInjectedTableView: function() {
      // if in design view and if table has no rows
      if (this.getOption('designable') && this.tableView.collection.length == 0) {
        this.addTableRow();
      }
      this.setupTableView();

      var answerValueMultiplicityArray = this.form.util.getLeafTemplateObjects(this.model).map(function(leaf) {
        return this.form.util.getAnswerValueCollection(leaf).length;
      }, this);

      var maxLength = Math.max.apply(Math, answerValueMultiplicityArray);

      for (var i = 0; i < maxLength; i++) {
        this.addTableRow();
      }
    },

    // COI-3060
    onInjectedTableViewWithMinRows: function() {
        // if in design view and if table has no rows
        if (this.getOption('designable') && this.tableView.collection.length == 0) {
            this.addTableRow();
        }
        this.setupTableView();

        var answerValueMultiplicityArray = this.form.util.getLeafTemplateObjects(this.model).map(function(leaf) {
            return this.form.util.getAnswerValueCollection(leaf).length;
        }, this);

        var minLength = 1;
        if(answerValueMultiplicityArray.length > 0) {
            var extOrgArrayLength = answerValueMultiplicityArray[0];

            if(extOrgArrayLength > 1) {
                minLength = extOrgArrayLength;
            }
        }
        console.log("onInjectedTableViewWithMinRows minLength="+ minLength);

        for (var i = 0; i < minLength; i++) {
            this.addTableRow();
        }
     },



    onInjectedAddRowButtonView: function(addRowButtonView) {
      var formObjectState = this.getOption('formObjectState');

      this.listenTo(formObjectState, 'change:isSavingAnswers', function(model, isSavingAnswers) {
        addRowButtonView.loading = isSavingAnswers;
      });
    },

    setupTableView: function() {
      this.tableView.columns.set(this.createTableViewColumnCollection());
    },

    onAddRowButtonViewPress: function() {
      var rowModel = this.addTableRow();

      rowModel.get('answers').each(function(answerValueModel) {
        this.form.triggerBeginEditAnswerEvent(this.tableView, answerValueModel.templateObjectModel, {
          answerValueModel: answerValueModel,
          triggeredByNewAnswerValueModel: true,
        });
        this.form.triggerEndEditAnswerEvent(this.tableView, answerValueModel.templateObjectModel, {
          answerValueModel: answerValueModel,
          triggeredByNewAnswerValueModel: true,
        });
      }, this);
    },

    addTableRow: function() {
      var answerValueCollection = new Backbone.Collection();
      var rowModel = new Backbone.Model({ answers: answerValueCollection });
      var leafs = this.form.util.getLeafTemplateObjects(this.model);

      this.tableView.collection.add(rowModel);

      var answerValueIndex = this.tableView.collection.indexOf(rowModel);

      leafs.each(function(leaf) {
        var answerValueModel = this.form.getAnswerValueModel(leaf, answerValueIndex);
        answerValueModel.templateObjectModel = leaf;
        answerValueCollection.add(answerValueModel);
      }, this);

      this.listenTo(rowModel, 'destroy', function(model, collection, options) {
        // remove answer value model
        var toRemove = [];
        answerValueCollection.each(function(answerValueModel) {
          this.stopListening(answerValueModel);
          toRemove.push(answerValueModel);
        }, this);

        _.each(
          toRemove,
          function(answerValueModel) {
            // parent collection is the real answer value collection
            // that lives in the form data structure
            var parentCollection = answerValueModel.collection;

            if (parentCollection) {
              parentCollection.remove(answerValueModel);
            }

            answerValueCollection.remove(answerValueModel);

            if (!_.result(options, 'isFromServer')) {
              this.form.triggerBeginEditAnswerEvent(this, answerValueModel.templateObjectModel, {
                answerValueModel: answerValueModel,
              });
              this.form.triggerEndEditAnswerEvent(this, answerValueModel.templateObjectModel, {
                answerValueModel: answerValueModel,
              });
            }
          },
          this
        );
      });

      return rowModel;
    },

    createTableViewColumnCollection: function(templateObjectModel) {
      var self = this;
      var formObjectState = this.getOption('formObjectState');
      var DELETE_TABLE_ROW_COLUMN = {
        collapsing: true,
        required: false,

        childView: UIKit.Button,
        childViewOptions: {
          icon: 'remove',
          color: 'red',
          inline: true,
          loading: false,
          disabled: this.getOption('readonly'),
        },
        onBeforeAdd: function(childView) {
          childView.disabled = self.getOption('readonly');

          this.listenTo(self, 'change:readonly', function() {
            childView.disabled = self.getOption('readonly');
          });

          childView.listenTo(formObjectState, 'change:isSavingAnswers', function(model, isSavingAnswers) {
            childView.loading = isSavingAnswers;
            childView.disabled = isSavingAnswers;
          });

          childView.on('press', function() {
            if (formObjectState.get('isSavingAnswers')) {
              return;
            } else {
              //just emits an event that can be used to elsewhere to cleanup the answer values
              childView.model.destroy();
            }
          });
        },
      };

      var columns = this.model.get('children').map(function(templateObjectModel) {
        var column = this.createTableViewColumnModel(templateObjectModel);

        // remove all old listeners
        this.stopListening(templateObjectModel);

        // add new listeners
        this.listenTo(templateObjectModel, 'change:text', function() {
          column.set('text', templateObjectModel.get('text'));
        });

        this.listenTo(templateObjectModel, 'change:required', function() {
          column.set('required', templateObjectModel.get('required'));
        });

        return column;
      }, this);

      columns.push(DELETE_TABLE_ROW_COLUMN);

      return columns;
    },

    createTableViewColumnModel: function(templateObjectModel) {
      var ContentView = this.getFormObjectContentViewType(templateObjectModel);
      var ContentViewPreviewAnswerView =
        ContentView.PreviewAnswerInsideTableView ||
        ContentView.PreviewAnswerView ||
        UIKit.ItemView.extend({ template: false });
      var tableContentView = this;
      var formObjectState = this.getOption('formObjectState');

      var tableViewColumnModel = new Backbone.Model({
        text: templateObjectModel.get('text'),
        required: templateObjectModel.get('required'),
        childView: ContentViewPreviewAnswerView.extend({
          getAndLinkAnswerValueModel: function(model, form) {
            return form.getAnswerValueModel(model, this.getAnswerValueIndex());
          },
          getAnswerValueIndex: function() {
            var rowViewModel = this.getOption('rowView').model;
            return rowViewModel.collection.indexOf(rowViewModel);
          },
        }),

        childViewOptions: {
          // all table children are multi answer values
          isMultiAnswerValue: true,
          form: this.form,
          model: templateObjectModel,
          readonly: this.getOption('readonly'),
          formValidationMode: null,
        },

        onBeforeAdd: function(childView) {
          if (childView instanceof ContentViewPreviewAnswerView) {
            childView.readonly = tableContentView.getOption('readonly');
            this.listenTo(tableContentView, 'change:readonly', function() {
              childView.readonly = tableContentView.getOption('readonly');
            });
          }
        },

        behaviors: {
          AnswerValueFailedValidationsBehavior: {
            templateObjectModel: templateObjectModel,
            formObjectState: formObjectState,
            form: this.getOption('form'),
            previewAnswerView: function() {
              return this.view.columnChildView;
            },
            onFailedVisibleValidations: function(failedVisibleValidations) {
              this.view.negative = failedVisibleValidations.length > 0;
            },
            behaviorClass: AnswerValueFailedValidationsBehavior,
          },
          setIsSavingAnswers: {
            behaviorClass: Mn.Behavior.extend({
              onFirstBeforeRender: function() {
                this.listenTo(
                  FormObjectUtil.getAnswerValueCollection(templateObjectModel),
                  'begin:answer:save',
                  function() {
                    formObjectState.set('isSavingAnswers', true);
                  }
                );

                this.listenTo(
                  FormObjectUtil.getAnswerValueCollection(templateObjectModel),
                  'end:answer:save',
                  function() {
                    formObjectState.set('isSavingAnswers', false);
                  }
                );
              },
            }),
          },
        },
      });

      return tableViewColumnModel;
    },

    getFormObjectContentViewType: function(templateObjectModel) {
      var ContentView;
      if (!this.form) {
        var message = 'Error getting template object content view type. Base form object view instance has no form.';
        Promise.reject(new Error(message));
        ContentView = BaseContentView.extend({ template: false });
      } else {
        ContentView = this.form.getContentView(this.form.getTemplateObjectTypeName(templateObjectModel));
      }

      return ContentView;
    },
  });

  var TableContentView = BaseSelectableContentView.extend({
    internalViewOptions: BaseSelectableContentView.extendInternalViewOptions({
      designAnswerView: function() {
        return {
          type: DesignAnswerView,
          templateObjectTypeCollection: this.getFilteredTemplateObjectTypeCollection(),
        };
      },
      previewAnswerView: function() {
        return {
          type: PreviewAnswerView,
          collection: new Backbone.Collection(),
        };
      },
    }),

    getFilteredTemplateObjectTypeCollection: function() {
      var templateObjectTypeCollection = this.form.getTemplateObjectTypeCollection();

      return new Backbone.Collection(
        templateObjectTypeCollection.filter(function(templateObjectType) {
          return templateObjectType.get('isTableNestable') === true;
        }, this)
      );
    },

    updateChangedStatusAttributes: function() {
      BaseContentView.prototype.updateChangedStatusAttributes.apply(this, arguments);

      this.ui.answerWrapper.css({
        'overflow-x': 'auto',
      });
    },
  });

  TableContentView.DesignAnswerItemView = DesignAnswerItemView;
  TableContentView.DesignAnswerCollectionView = DesignAnswerCollectionView;
  TableContentView.DesignAnswerView = DesignAnswerView;
  TableContentView.PreviewAnswerView = PreviewAnswerView;

  return TableContentView;
});

